import {ClientContractListState} from "../store/client_contracts_state";
import {Reducer} from "redux";
import {
    ClientContractListAction,
    ClientContractListActionType,
    ICallbackGetAllContractListByClientAction,
} from "../action/client_contracts_action";

const initialState: ClientContractListState = {
    projectList: {
        isLoading: false,
    },
    customerList: {
        isLoading: false,
    },
    contractList: {
        isLoading: false,
    },
    contractCount: {
        isLoading: false,
    },
};

const clientContractListReducer: Reducer<ClientContractListState> = (state = initialState, action: ClientContractListAction): ClientContractListState => {
    switch (action.type) {

        case ClientContractListActionType.REQUEST_GET_ALL_CONTRACT_LIST_BY_CLIENT: {
            return Object.assign({}, state, {
                projectList: {
                    isLoading: true,
                    item: state.projectList.item,
                },
                customerList: {
                    isLoading: true,
                    item: state.customerList.item,
                },
                contractList: {
                    isLoading: true,
                    item: state.contractList.item,
                },
                contractCount: {
                    isLoading: true,
                    item: state.contractCount.item,
                },
            });
        }
        case ClientContractListActionType.CALLBACK_GET_ALL_CONTRACT_LIST_BY_CLIENT: {
            const _action = action as ICallbackGetAllContractListByClientAction;
            if (action.isSuccess) {
                return Object.assign({}, state, {
                    projectList: {
                        isLoading: false,
                        error: undefined,
                        item: (_action.item) ? _action.item.projectList : undefined,
                    },
                    customerList: {
                        isLoading: false,
                        error: undefined,
                        item: (_action.item) ? _action.item.customerList : undefined,
                    },
                    contractList: {
                        isLoading: false,
                        error: undefined,
                        item: (_action.item) ? _action.item.contractList : undefined,
                    },
                    contractCount: {
                        isLoading: false,
                        error: undefined,
                        item: (_action.item) ? _action.item.contractCount : undefined,
                    },
                });
            } else {
                return Object.assign({}, state, {
                    projectList: {
                        isLoading: false,
                        error: _action.error,
                    },
                    customerList: {
                        isLoading: false,
                        error: _action.error,
                    },
                    contractList: {
                        isLoading: false,
                        error: _action.error,
                    },
                    contractCount: {
                        isLoading: false,
                        error: _action.error,
                    },
                });
            }
        }

        default:
            return state;
    }
};

export default clientContractListReducer;



// WEBPACK FOOTER //
// ./src/presentation/reducer/client_contracts_reducer.ts